"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyProjectileAttacksWithDamage = void 0;
const __1 = require("../..");
const Calculators_1 = require("../state/Calculators");
function applyProjectileAttacksWithDamage(args) {
    const { abilityKey, attackType, attackerId, projectiles, onHit, onMiss, onHitOrMiss } = args;
    if (projectiles.length === 0) {
        return;
    }
    const applyProjectileAttackFromArgs = (args, tickOnly, // Whether or not just to tick, ticks won't animate the invoker
    sequence, onBeforeDamage = () => { }) => {
        this.applyProjectileAttackWithDamage({
            attackerId,
            targetId: args.targetId,
            originId: args.originIdOverride,
            abilityKey,
            attackType: tickOnly ? (0, Calculators_1.mkAttackTypeTick)(attackType) : attackType,
            projectileType: args.type,
            projectilePath: args.path,
            startAtAttachment: args.start,
            endAtAttachment: args.end,
            toApply: args.damages,
            sequence,
            onBeforeDamage,
            onHit: (hitSequence, attack, damages) => {
                onHit === null || onHit === void 0 ? void 0 : onHit(hitSequence, attack, damages, args);
                onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(hitSequence, attack, args);
            },
            onMiss: (missSequence, attack) => {
                onMiss === null || onMiss === void 0 ? void 0 : onMiss(missSequence, attack, args);
                onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(missSequence, attack, args);
            }
        });
    };
    const [first, ...others] = projectiles;
    // Keeps the time elapsed from other jitters, since each jitter duration is one after another
    // Example, p1 jitter = 50ms, p2 jitter = 75ms. p1 runs at 50ms, p2 runs at 125ms (previous times => 50ms + 75ms).
    let jitterMsCursor = first.jitter || 0;
    applyProjectileAttackFromArgs(first, false, jitterMsCursor > 0
        ? args.sequence.pushSequence("sequential").push(__1.DelayVfxStepArgs.ms(jitterMsCursor))
        : args.sequence.pushSequence("sequential"), (sequence) => {
        const innerSequence = sequence.pushSequence("parallel");
        for (let i = 0; i < others.length; i++) {
            const args = others[i];
            jitterMsCursor += (args.jitter || 0);
            const withJitter = jitterMsCursor > 0
                ? innerSequence.pushSequence("sequential").push(__1.DelayVfxStepArgs.ms(jitterMsCursor))
                : innerSequence.pushSequence("sequential");
            applyProjectileAttackFromArgs(others[i], true, withJitter);
        }
    });
}
exports.applyProjectileAttacksWithDamage = applyProjectileAttacksWithDamage;
